import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stack,
} from '@mui/material';
import {
  KeyboardArrowUp as ArrowUpIcon,
  KeyboardArrowDown as ArrowDownIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

export default function BodyParameterField({
  index,
  value,
  error,
  onChange,
  onRemove,
  onMoveUp,
  onMoveDown,
  positional,
  isFirst,
  isLast,
  edit,
}) {
  const handleChange = (field, fieldValue) => {
    const newValue = { ...value, [field]: fieldValue };
    onChange(index, newValue);
  };

  const handleOptionalChange = (checked) => {
    const newValue = {
      ...value,
      optional: checked,
      default_value: checked ? value.default_value : '',
    };
    onChange(index, newValue);
  };

  return (
    <Stack direction='row' spacing={1} alignItems='flex-start'>
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            label='Name'
            id={`body-name-${index}`}
            value={value.name || ''}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder='image'
            error={Boolean(error?.name_error || error?.dup_error)}
            helperText={
              error?.name_error
                ? 'Please Enter Valid Name'
                : error?.dup_error
                ? 'Duplicate Name'
                : ''
            }
            variant='outlined'
            fullWidth
            disabled={edit}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <FormControl fullWidth>
            <InputLabel id={`body-type-${index}-label`}>Data Type</InputLabel>
            <Select
              labelId={`body-type-${index}-label`}
              id={`body-type-${index}`}
              value={value.type || ''}
              label='Data Type'
              onChange={(e) => handleChange('type', e.target.value)}
              disabled={edit}
            >
              <MenuItem value='str'>String</MenuItem>
              <MenuItem value='int'>Integer</MenuItem>
              <MenuItem value='float'>Float</MenuItem>
              <MenuItem value='bool'>Boolean</MenuItem>
              <MenuItem value='dict'>Object</MenuItem>
              <MenuItem value='list'>List</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, sm: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value.optional || false}
                onChange={(e) => handleOptionalChange(e.target.checked)}
                disabled={edit}
              />
            }
            label='Optional'
            sx={{ mt: 1 }}
          />
        </Grid>
        {value.optional && (
          <Grid size={{ xs: 12, sm: 3 }}>
            <TextField
              label='Default Value'
              id={`body-default-${index}`}
              value={value.default_value || ''}
              onChange={(e) => handleChange('default_value', e.target.value)}
              placeholder='None'
              error={Boolean(error?.default_value_error)}
              helperText={
                error?.default_value_error ? 'Please Enter a Value' : ''
              }
              variant='outlined'
              fullWidth
              disabled={edit}
            />
          </Grid>
        )}
        {!value.optional && <Grid size={{ xs: 12, sm: 3 }} />}
      </Grid>
      <Stack direction='row' spacing={0.5} sx={{ mt: 1 }}>
        {!isFirst && positional && (
          <IconButton
            size='small'
            onClick={() => onMoveUp(index)}
            disabled={edit}
          >
            <ArrowUpIcon />
          </IconButton>
        )}
        {!isLast && positional && (
          <IconButton
            size='small'
            onClick={() => onMoveDown(index)}
            disabled={edit}
          >
            <ArrowDownIcon />
          </IconButton>
        )}
        <IconButton size='small' onClick={() => onRemove(index)} color='error'>
          <CloseIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
}

